// Session: the JWT from POST /v1/login, kept in localStorage under the same
// keys the v1.1 UI used ("token", "authUser") so legacy pages keep working.
import jwtDecode from "jwt-decode";
import { setAuthorization } from "../../helpers/api_helper";

export const LOGIN_PATH = "/login";

export const getToken = () => {
    try {
        return localStorage.getItem("token");
    } catch (e) {
        return null;
    }
};

const isExpired = (token) => {
    try {
        const { exp } = jwtDecode(token);
        return exp ? exp * 1000 < Date.now() : false;
    } catch (e) {
        return true;
    }
};

export const isLoggedIn = () => {
    const t = getToken();
    return !!t && !isExpired(t);
};

export const currentUser = () => {
    try {
        return JSON.parse(localStorage.getItem("authUser")) || null;
    } catch (e) {
        return null;
    }
};

export const saveSession = (token) => {
    localStorage.setItem("token", token);
    let user = {};
    try {
        user = jwtDecode(token);
    } catch (e) {
        user = {};
    }
    localStorage.setItem("authUser", JSON.stringify(user));
    setAuthorization(token); // legacy APIClient (Talent, Content pages)
};

export const clearSession = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("authUser");
};

// Sign out and go to the login page; message is shown there once.
export const logout = (message) => {
    clearSession();
    if (message) {
        try {
            sessionStorage.setItem("hz-login-msg", message);
        } catch (e) {
            // ignore
        }
    }
    if (window.location.pathname !== LOGIN_PATH) window.location.href = LOGIN_PATH;
};

export const takeLoginMessage = () => {
    try {
        const m = sessionStorage.getItem("hz-login-msg");
        sessionStorage.removeItem("hz-login-msg");
        return m;
    } catch (e) {
        return null;
    }
};
